import { Panel, PanelPosition } from "@swivl-mono/ui";
import React, { useEffect } from "react";

import { UserDetailsCardVariant } from "../../../Components/UserDetailsCard/UserDetailsCard";
import { UsersModel } from "../../../Models/Users/Users.Model";
import UserVarsModel from "../../../Models/Variables/UserVars.Model";
import UserDetails, { UserDetailsTabID } from "../../ContactCenter/Conversations/DetailsColumn/UserDetails";

interface TicketCustomerFlyoutProps {
  /** The ticket's customer (user) id; null when no customer. */
  userId: number | null;
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Right slide-over showing a customer's details — the same flyout used on the
 * CRM page (Panel + UserDetails), opened in place over the ticket via the
 * "View" button on the Customer field.
 */
export function TicketCustomerFlyout({ userId, isOpen, onClose }: TicketCustomerFlyoutProps): React.JSX.Element {
  const { users } = UsersModel.useState();
  const { vars } = UserVarsModel.useState((s) => s);

  useEffect(() => {
    if (userId == null) return;
    void UserVarsModel.loadForUser(userId);
    void UsersModel.loadUsersByIds([userId]);
  }, [userId]);

  const user = userId != null ? users?.[userId] : undefined;
  const userVars = userId != null ? vars?.[userId] : undefined;

  return (
    <Panel
      isOpen={isOpen}
      onToggle={onClose}
      position={PanelPosition.RIGHT}
      title="Customer Details"
      // Match the ticket flyout: quicker, smoother slide than the Panel default.
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
    >
      {user && (
        <UserDetails
          tabs={[
            { id: UserDetailsTabID.Details, label: "Customer Details", badge: false },
            { id: UserDetailsTabID.Notes, label: "Notes", badge: false }
          ]}
          user={user}
          userVars={userVars}
          userCardVariant={UserDetailsCardVariant.DETAILED}
        />
      )}
    </Panel>
  );
}
